export default "__VITE_ASSET__DBorDCua__"